import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/subscriptions/list",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/pages/Dashboard.vue"),
          meta: {
            authRequired: true,
          },
        },
        {
          path: "/builder",
          name: "builder",
          component: () => import("@/view/pages/Builder.vue"),
        },
        {
          path: "/medicines",
          name: "medicines",
          component: () => import("@/view/pages/medicines/Medicines.vue"),
          children: [
            {
              path: "availability",
              name: "medicines-availability",
              component: () =>
                import("@/view/pages/medicines/Availability.vue"),
              meta: {
                authRequired: true,
              },
            },
          ],
        },
        {
          path: "/products",
          name: "products",
          component: () => import("@/view/pages/products/Products.vue"),
          children: [
            {
              path: "list",
              name: "products-list",
              component: () =>
                import("@/view/pages/products/List.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "brands",
              name: "products-brands",
              component: () =>
                import("@/view/pages/products/Brands.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "categories",
              name: "products-categories",
              component: () =>
                import("@/view/pages/products/Categories.vue"),
              meta: {
                authRequired: true,
              },
            },
          ],
        },      
        {
          path: "/subscriptions",
          name: "requests",
          component: () => import("@/view/pages/requests/Requests.vue"),
          children: [
            {
              path: "list",
              name: "requests-list",
              component: () => import("@/view/pages/requests/List.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "withoutresult",
              name: "requests-without-result-list",
              component: () => import("@/view/pages/requests/RequestsWithoutResut.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "toprocess",
              name: "requests-reservations",
              component: () => import("@/view/pages/requests/Reservations.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "scheduledreservations",
              name: "requests-scheduledreservations",
              component: () => import("@/view/pages/requests/ScheduledReservations.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "referrals",
              name: "requests-quotes",
              component: () => import("@/view/pages/requests/Quotes.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "promotions",
              name: "requests-promotions",
              component: () => import("@/view/pages/requests/Promotions.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "detail/:guid",
              name: "requests-detail",
              component: () => import("@/view/pages/requests/Detail.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "detail/statehistory/:guid",
              name: "requests-detai-statehistory",
              component: () => import("@/view/pages/requests/StateHistory.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "detail/requestdetail/:guid",
              name: "requests-detai-requestdetail",
              component: () => import("@/view/pages/requests/RequestDetail.vue"),
              meta: {
                authRequired: true,
              },
            },
          ],
        },
        {
          path: "/services",
          name: "services",
          component: () => import("@/view/pages/services/Services.vue"),
          children: [
            {
              path: "list",
              name: "services-list",
              component: () => import("@/view/pages/services/List.vue"),
              meta: {
                authRequired: true,
              },
            },                 
            {
              path: "detail/:guid",
              name: "services-detail",
              component: () => import("@/view/pages/services/Detail.vue"),
              meta: {
                authRequired: true,
              },
            },
           
          ],
        },
        {
          path: "/clients",
          name: "clients",
          component: () => import("@/view/pages/clients/Clients.vue"),
          children: [
            {
              path: "list",
              name: "clients-list",
              component: () => import("@/view/pages/clients/List.vue"),
              meta: {
                authRequired: true,
              },
            },   
            {
              path: "withoutresults",
              name: "clients-without-results",
              component: () => import("@/view/pages/clients/WithoutResults.vue"),
              meta: {
                authRequired: true,
              },
            },          
            {
              path: "detail/:guid",
              name: "clients-detail",
              component: () => import("@/view/pages/clients/Detail.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "messages",
              name: "clients-messages",
              component: () => import("@/view/pages/clients/Messages.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "messages/detail/:guid",
              name: "clients-messages-detail",
              component: () => import("@/view/pages/clients/MessageDetail.vue"),
              meta: {
                authRequired: true,
              },
            },
            {
              path: "results/:guid",
              name: "clients-results",
              component: () => import("@/view/pages/clients/Results.vue"),
              meta: {
                authRequired: true,
              },
            },
          ],
        },
        {
          path: "/users",
          name: "users",
          component: () => import("@/view/pages/users/Users.vue"),
          children: [
            {
              path: "profile",
              name: "users-profile",
              component: () => import("@/view/pages/users/Profile.vue"),
              meta: {
                authRequired: true,
              },
            },
          ],
        },
        {
          path: "/pharmacy",
          name: "pharmacy",
          component: () => import("@/view/pages/pharmacy/Pharmacy.vue"),
          meta: {
            authRequired: true,
          },
        },
      ],
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue"),
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue"),
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue"),
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue"),
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue"),
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue"),
        },
      ],
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login"),
        },
        {
          name: "forgotpassword",
          path: "/forgotpassword",
          component: () => import("@/view/pages/auth/ForgotPassword"),
        },
        {
          name: "resetpassword",
          path: "/resetpassword",
          component: () => import("@/view/pages/auth/ResetPassword"),
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Register"),
        },
        {
          name: "selectpharmacy",
          path: "/selectpharmacy",
          component: () => import("@/view/pages/auth/SelectPharmacy"),
          meta: {
            authRequired: true,
          },
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue"),
    },
  ],
});
